import React from 'react';

export const CodeITTLogo = ({ size = 'default', className = '' }) => {
  const sizes = {
    small: 'h-10',
    default: 'h-14',
    large: 'h-20',
    xl: 'h-28',
  };
  return (
    <img
      src="/assets/logo.png"
      alt="CodeITT"
      className={`${sizes[size] || sizes.default} w-auto object-contain rounded-xl ${className}`}
      data-testid="codeitt-logo"
    />
  );
};
